
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/fachkompetenz/member-card.kpa`,
      template: `<div class="member-card box-shadow">
        <div class="member-img">
            <img src="{{img}}" alt="Portrait von {{name}}"/>
        </div>

        <div class="member-info">
            <svg class="double-hex-svg" width="100%" height="100%" viewBox="0 0 226 275" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
                <g id="Dubble-Hex" serif:id="Dubble Hex" transform="matrix(1,0,0,1,-558,-217)">
                    <g transform="matrix(1,0,0,1,-294,-280)">
                        <path d="M952.5,505L1045.6,558.75L1045.6,666.25L952.5,720L859.402,666.25L859.402,558.75L952.5,505Z" style="fill:none;stroke:rgb(44,65,67);stroke-width:14.69px;"/>
                    </g>
                    <g transform="matrix(1,0,0,1,-269,-236)">
                        <path d="M952.5,505L1045.6,558.75L1045.6,666.25L952.5,720L859.402,666.25L859.402,558.75L952.5,505Z" style="fill:none;stroke:rgb(100,193,108);stroke-width:14.69px;"/>
                    </g>
                </g>
            </svg>

            <h3>{{name}}</h3>
            <p><strong>{{beruf}}</strong></p>
            <p>{{spez}}</p>
            <p>{{text}}</p>
        </div>
    </div>`,
      style: `member-card .member-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: var(--roundness);
  width: 100%;
  height: 710px;
  margin-bottom: 64px;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}
member-card .member-card .member-img {
  position: relative;
  width: 100%;
  height: 440px;
  overflow: hidden;
}
member-card .member-card .member-img img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}
member-card .member-card .member-info {
  position: relative;
  border-top: 5px solid #64c16c;
  min-width: 100%;
  padding-top: 1rem;
}
member-card .member-card .member-info .double-hex-svg {
  position: absolute;
  top: -65px;
  right: 16px;
  max-width: 80px;
  height: auto;
}
member-card .member-card .member-info h3 {
  padding: 0 16px;
}
member-card .member-card .member-info p {
  padding: 0 16px;
}
member-card .member-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
}
@media (max-width: 839px) {
  member-card .member-card {
    width: 400px;
    height: 700px;
  }
  member-card .member-card p {
    font-size: 1.2rem;
  }
}
@media (min-width: 840px) {
  member-card .member-card {
    width: 380px;
    height: 700px;
  }
  member-card .member-card p {
    font-size: 1.2rem;
  }
}
@media (min-width: 900px) {
  member-card .member-card {
    width: 400px;
    height: 700px;
  }
}
@media (min-width: 1200px) {
  member-card .member-card {
    width: 500px;
    height: 710px;
  }
}
@media (min-width: 2560px) {
  member-card .member-card {
    height: 740px;
  }
}
@media (max-width: 500px) {
  member-card .member-card {
    width: 350px;
    height: 650px;
  }
  member-card .member-card h3 {
    font-size: 1.5rem;
  }
  member-card .member-card p {
    font-size: 1rem;
  }
}
@media (max-width: 400px) {
  member-card .member-card {
    position: relative;
    left: -32px;
    width: calc(100% + 64px);
    height: 650px;
    border-radius: 0;
  }
  member-card .member-card h3 {
    font-size: 1.5rem;
  }
  member-card .member-card p {
    font-size: 1rem;
  }
}
@media (max-width: 350px) {
  member-card .member-card {
    height: 700px;
  }
  member-card .member-card .member-info {
    padding-top: 2.2rem;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
    props: {
        img: {
            type: 'string',
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        beruf: {
            type: String,
            default: "",
        },
        spez: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "",
        },
    },
    events: [
        ['click', '.member-card', function (event) {
                console.log("Member card clicked!");
                dialog.createDialog(\`<modal-$-{this.type}></modal-$-{this.type}>\`, 'modal');
            }],
    ],
};
 })()`
    };
  